import React, { useEffect, useState } from 'react';
import Desktop from './Desktop';
import Mobile from './Mobile';

function Header() {
	const [screenWidth, setScreenWidth] = useState(0);

	const handleWindowResize = () => {
		setScreenWidth(window.innerWidth);
	};

	useEffect(() => {
		handleWindowResize();
		window.addEventListener('resize', handleWindowResize);

		return window.addEventListener('resize', handleWindowResize);
	}, [screenWidth]);

	return (
		<header className={`w-full h-auto mx-auto py-0 md:py-6 shadow-xl`}>
			<div className="max-w-screen-2xl h-fit m-auto">
				{screenWidth > 767 ? <Desktop /> : <Mobile />}
			</div>
		</header>
	);
}

export default Header;
